import React, {Component} from 'react';
import About from '../../widgets/index/about';
import Services from '../../widgets/index/services';
import Work from '../../widgets/index/work';
import Herosection from '../../widgets/herosection/herosection';

class Index extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }


    render() {
        return (<div>
            <section id="home" style={{backgroundColor: '#0d153b', height: '600px'}}>
                <div className="container-fluid">
                    <Herosection/>
                </div>
            </section>
            <div className="page-content">
                {/* Stats Section */}
                <section className="py-5 bg-light">
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
                                <div>
                                    <h2 className="display-4 text-primary mb-0">99.9%</h2>
                                    <p className="lead mb-0">Accuracy Rate</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
                                <div>
                                    <h2 className="display-4 text-primary mb-0">&lt;4s</h2>
                                    <p className="lead mb-0">Average Verification Time</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
                                <div>
                                    <h2 className="display-4 text-primary mb-0">95%</h2>
                                    <p className="lead mb-0">Fraud Detection Rate</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div>
                                    <h2 className="display-4 text-primary mb-0">24/7</h2>
                                    <p className="lead mb-0">Support & Uptime</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="row mx-auto mt-5">
                    <div class="col-12  " align="center">
                        <div class="margin-bottom margin-small">
                            <h2 class="heading-18">Why Choose Nafsi</h2>
                        </div>
                    </div>
                    <div class=" col-12  " align="center">
                        <div style={{width: 900}}>
                            <p style={{fontSize: 18}}>One unified platform for all your identity verification needs.
                                Deploy in minutes with our simple API, scale effortlessly with our queue-based
                                architecture, and stay compliant with built-in fraud detection and document
                                authentication.</p>

                        </div>
                    </div>
                </div>
                {/*about start*/}
                <About/>
                {/*about end*/}
                {/*services start*/}
                <Services/>
                {/*services end*/}
                {/*work start*/}
                <Work/>
                {/*work end*/}
            </div>
        </div>);
    }
}

export default Index;
